import { render, staticRenderFns } from "./new_menu.vue?vue&type=template&id=adefe156&scoped=true"
import script from "./new_menu.vue?vue&type=script&lang=js"
export * from "./new_menu.vue?vue&type=script&lang=js"
import style0 from "./new_menu.vue?vue&type=style&index=0&id=adefe156&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adefe156",
  null
  
)

export default component.exports